import React from 'react';

import ModerationPage from 'components/moderation';

const Moderation = () => <ModerationPage />;

export default Moderation;
